var React = require('react');
var createReactClass = require('create-react-class');
var Loader = require('react-loader');
var PostContainer = require('./layout/postContainer.jsx');
var PostContainerHelmet = require('./layout/postContainerHelmet.jsx');

var Post = createReactClass({

  	componentDidMount: function() {
        this.props.fetchPostIfNeeded(this.props.params.categorySlug, this.props.params.slug);
    },

    hasDataLoaded: function(){
        return !!(Object.keys(this.props.post.data).length > 0 && !this.props.post.isFetching);
    },

	render: function () {
        var children = [
            <PostContainerHelmet postContainer={this.props.post.data} key={0} />,
            <div className="row" key={1}>
                <div className="column xlarge-10 xlarge-centered">
                    <PostContainer postContainer={this.props.post.data} />
                </div>
            </div>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return (
            <div className="content">
                {content}
            </div>
        );
    }
});

module.exports = Post;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/post.jsx